/**
 * The words of "raportări" in the portal (14.10.2026) — the tickets of the
 * admin, as trainers, the committee and participants read them. Validated
 * by FPED in docs/texte-tichete-portal-pr5-2026-10-14.md.
 */

export const PORTAL_RULE =
  "Aici semnalezi doar probleme ale portalului: ceva nu merge sau ar putea merge mai bine. " +
  "Pentru întrebări despre curs, teme sau note, scrie-i formatorului tău sau la contact@fped.org.";

export const SCREENSHOT_WARNING =
  "Nu pune în capturi CNP-ul tău, date de card sau datele altor cursanți. " +
  "Capturile rămân la raportare și le vede doar echipa FPED.";

export const REPORT_KIND = {
  bug: { label: "Ceva nu merge", describe: "Ce s-a întâmplat" },
  suggestion: { label: "Am o sugestie", describe: "Ce ai propune" },
};
export const REPORT_KIND_ORDER = ["bug", "suggestion"];

export const REPORT_IMPACT = {
  blocking: "Nu pot continua",
  annoying: "Mă încurcă",
  nice_to_have: "Ar fi bine",
};
export const REPORT_IMPACT_ORDER = ["blocking", "annoying", "nice_to_have"];

export const REPORT_STATUS = {
  new: { label: "Primită", tone: "info" },
  needs_info: { label: "Avem nevoie de detalii", tone: "warn" },
  planned: { label: "Planificată", tone: "info" },
  in_progress: { label: "În lucru", tone: "info" },
  to_verify: { label: "Verifică, te rog", tone: "good" },
  resolved: { label: "Rezolvată", tone: "good" },
  reopened: { label: "Redeschisă", tone: "warn" },
  rejected: { label: "Închisă", tone: "neutral" },
  duplicate: { label: "Închisă: știam deja de această problemă", tone: "neutral" },
};

/** The group a page belongs to, from its address, for the report made from it. */
export function groupFromPath(path = "") {
  const m = /^\/portal\/(?:grupa|portofoliu|evaluare)\/([^/?#]+)/.exec(path);
  return m ? m[1] : "";
}

/**
 * Where "Raportează o problemă" leads from a page: the form, knowing the page.
 * The guide (19.10.2026) also starts the form with a kind and a title.
 */
export function reportHref(path = "", prefill = null) {
  const q = new URLSearchParams({ nou: "1" });
  if (path) q.set("din", path);
  if (prefill?.kind) q.set("fel", prefill.kind);
  if (prefill?.title) q.set("titlu", prefill.title);
  if (prefill?.description) q.set("text", prefill.description);
  return `/portal/raportari?${q.toString()}`;
}

/** The fields a report form starts with, from the address `reportHref` made. */
export function prefillFrom(params) {
  const kind = params.get("fel");
  return {
    kind: REPORT_KIND[kind] ? kind : "",
    title: (params.get("titlu") || "").slice(0, 160),
    description: (params.get("text") || "").slice(0, 2000),
  };
}

/** What the reporter is told after sending. */
export function sentLine(label) {
  return `Am primit raportarea ${label}. Îți scriem pe email când se schimbă ceva. O găsești și în „Raportările mele”.`;
}
